const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDairy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dairy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.53,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "dairy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "milk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.08,329.63H508.71a0,0,0,0,1,0,0V844.71a6.94,6.94,0,0,1-6.94,6.94H246.08a0,0,0,0,1,0,0v-522A0,0,0,0,1,246.08,329.63Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.08,851.65,143.33,801.83a7.52,7.52,0,0,1-4.24-6.78V277.76l107,51.87Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 209.06 246.08 329.63 508.71 329.63 377.4 209.06",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.85 256.74 245.82 329.63 508.45 329.63 366.85 256.74",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.49 329.63 139.09 277.76 270.66 157.18 377.14 208.75 245.49 329.63",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,209.31l-106.4-51.88V136.81a5.4,5.4,0,0,1,7.66-4.91L370,174.1a12.18,12.18,0,0,1,7.09,11.09Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.83,
    y: 401.07,
    width: 262.63,
    height: 359.36,
    style: {
      fill: "#a4e1ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.82 760.42 139.09 713.96 139.09 354.6 245.82 401.07 245.82 760.42",
    style: {
      fill: "#8bd3ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,493.92c-.93.22-1.38.87-1.34,1.08-.58.62-.06,1.94.27,2.69l1.46,1c.59.48.17.12.17.12l.42.36c.24.27-.09,0,.19.23l.63.55c1.85,2.43,7.34,8.09,5.29,11a2,2,0,0,1-2.26.57c-2.65-.83-4.25-1.62-7.21-1.42-6.33.43-12.64.29-18.92.64-2.13.12-3.3,1.91-5.23,2.25s-5.12-1.41-6.85-2.37a8.91,8.91,0,0,1-4.73-9.69c.31-1.45,1.41-2.79,1.58-4.23.15-1.27-1-1.65-2.07-1.6-4.44.18-5.47,7-6,10.4a17.49,17.49,0,0,0,13.14,19.26l-.33,1.63c-7.56-2.46-14-1.62-20.23,3.69-1.88,1.6-5.09,4.58-4,7.4.84,2.18,3.92,2.9,6,3.33a42.32,42.32,0,0,0,17.29-.06c0,2.65-.21,5.74-1.43,8.16-2.58,5.13-8.51,11.28-4.88,17.87.69,1.26,2.28.9,3.38,1.57,4.58,2.79,8.26,3.76,13.7,2.53,1.44-.32,4.75-2.52,6.08-1.78.92.52,1.39,2.08,1.84,3,1.31,2.63,2.76,5.19,4.08,7.83,3.55,7.11,7.37,14.1,10.93,21.21,1.44,2.89,3.5,6,4.48,9.06h0a56.31,56.31,0,0,0,.22,6.23,19.27,19.27,0,0,0-.08,4.28c.91,6.62,2.71,13.66,3,20.43a45,45,0,0,1-.33,6.55c-.91,7.35-3.33,14.37-5.86,21.32-2.3,4.15-5.7,7.91-7,12.4l6.85,1.64.33.32c3,0,9.84,1,11.87-1.7,1.59-2.15.34-6,.11-9.08h.15a7.09,7.09,0,0,1,0-2.35,4.26,4.26,0,0,1,.17-.54c.68-1.7,3.05-1.19,3.58-3s-.21-4.07-.42-5.85a47.2,47.2,0,0,1-.06-8.49c.51-7.55,3.19-15.1,3.26-22.61l.06-.32a12.09,12.09,0,0,0-.56-5.27c-.05-.28-.11-.56-.18-.85a30.28,30.28,0,0,0,16.64-2.28c6.63,15.37,20.86,28.24,15.75,46.67-.68,2.44-2,4.52-2.91,6.85-.46,1.17-.28,2.51-1,3.59-1.81,2.88-4.76,4.87-6,8.16,4.91,2.79,10,2.44,15.33,1.43,1.53-.28,4.23-.48,5.36-1.66.6-.63.45-1.59.85-2.33s1.37-1.39,1.7-2.34c.81-2.35-.6-6.42-1-8.81,7.06-.62,3.77-8.45,2.61-13.05-2.17-8.59-4.24-17.22-6.49-25.78-1.24-4.7-3-9.54-3.63-14.36,6.77.53,13.69.52,20.24-1.63a56.49,56.49,0,0,0,7.5-3c.9-.45,2.4-1.59,3.45-1.34s1.73,1.37,2.43,2c2,1.71,5.82,3.27,7.17,5.44.83,1.34-.13,3.76,1.18,4.88,1.62,1.38,3-2.36,3.39-3.37,1.39,1.38,2.55,2.71,4.57,2.93l.33-5.87c2.48.38,3.48,3.42,5.84,3.73,2.88.37,1-5.65,1.54-6.94.42-1.07,1.66-1.81,2.41-2.67H444c5.16,9.71,5.55,18,3.1,28.72-1.05,4.58-2.51,6.57-5.27,10.18-.68.88-.45,1.48.21,2.22V655l-3.59,4.24a11.78,11.78,0,0,0,6.53,1.64l-4.78,5.22-.45,2.7-3.91,5.13v.33c6.87,4.9,13.42,3.79,20.23-.33-1.2-2.95-1.82-7.46,0-10.39,1.21-1.91,4-3,3.81-5.6-.16-2.85-1.45-5.6-1.54-8.49-.19-5.9,1.7-12.61,3.21-18.27,1.17-4.35,4.59-8.22,5.19-12.73.41-3.07-1.84-5.88-2.39-8.81-.74-4,.45-8.55,1.29-12.4,1.87-8.51,4.57-17.08,5.36-25.78.39-4.29-.27-9.34-.57-13.71-.38-5.49-1.11-11.67-3.62-16.65,4.25,4.12,4.84,10.45,5.25,16,.92,12.57-.22,26-2.18,38.51-1.12,7.16-6.83,17.07,1.5,22.68,1.49,1,2.81-.15,3.92-1.17,2.48-2.32,3.68-4.77,2.74-8.13s-3.51-6.07-3.93-9.47c-.6-4.85,1.15-10.46,1.48-15.34,1.09-15.88,2.28-34-5.27-48.62-5.14-9.94-15.68-12-26-11.75-9.76.24-19.23,3.24-28.72,5a122.09,122.09,0,0,1-22.19,1.72c-8.12,0-16.38-.28-24.47-.84-3-.2-6.16.35-9.14-.07-2.45-.35-4.74-2.39-7.18-3.08-5.68-1.6-11-.94-16.65.51-.12-2.38,1.74-2.76,3.26-4.25a16.59,16.59,0,0,0,3.89-6.19c3.6-10.61-6.57-21.7-16.94-22.69Zm14,185v0h0v0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "cottage-cheese"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.84,709.19H566.41a16.53,16.53,0,0,1-16.51-15.87L543,520.24h19.37A335.35,335.35,0,0,0,642.84,709.19Z",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.3,519.51H533.1a5.88,5.88,0,0,1,0-11.75H543a37.47,37.47,0,0,1,18.21-32.14q-.27,6.67-.27,13.4c0,6.3.18,12.53.52,18.74C561.66,511.69,562,515.62,562.3,519.51Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.44,520.24l-7,173.08A16.54,16.54,0,0,1,852,709.19H642.84a335.35,335.35,0,0,1-80.48-189Z",
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.2,513.63a5.86,5.86,0,0,1-5.87,5.88h-323c-.35-3.89-.64-7.82-.85-11.75H885.33A5.87,5.87,0,0,1,891.2,513.63Z",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.44,507.76h-314c-.34-6.21-.52-12.44-.52-18.74q0-6.72.27-13.4h0a37.39,37.39,0,0,1,19.26-5.32H838A37.46,37.46,0,0,1,875.44,507.76Z",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.62,460H803.81a9,9,0,0,1,9,9v.92a0,0,0,0,1,0,0H605.62a0,0,0,0,1,0,0V469A9,9,0,0,1,614.62,460Z",
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.42,592.8H631.77a10.14,10.14,0,0,1,2.43-8.42l0,0a10.24,10.24,0,0,1,8.13-3.37,10.18,10.18,0,0,1,12.43-10,10.12,10.12,0,0,1,.25-1.12C658.36,579.81,673,588.23,693.42,592.8Z",
    style: {
      fill: "#fff6ee",
      fillOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.05,592.8H693.42c-20.4-4.57-35.06-13-38.37-22.92a10.19,10.19,0,0,1,13.7-6.61A10.2,10.2,0,0,1,683.82,558a10.19,10.19,0,0,1,15.72-2.63,10.19,10.19,0,0,1,15.93.07,10.2,10.2,0,0,1,15.72,2.74,10.17,10.17,0,0,1,15,5.38,10.2,10.2,0,0,1,13.9,7.84,10.2,10.2,0,0,1,12.36,10.06A10.17,10.17,0,0,1,780.6,585,9.72,9.72,0,0,1,782,587,10,10,0,0,1,783.05,592.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.59,619.55a104.14,104.14,0,0,1-11.83,33.57c-15.55,6.35-34,10-53.85,10-55.38,0-100.28-28.74-100.28-64.2a43.33,43.33,0,0,1,.45-6.15h157c5.18,0,9.45,3.17,9.62,7.16A96.51,96.51,0,0,1,797.59,619.55Z",
    style: {
      fill: "#d6b0ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.76,653.12A128.3,128.3,0,0,1,771,674.2H643.24c-9.42-11-22.49-29.72-26.56-54.65A96.51,96.51,0,0,1,615.52,600c.17-4,4.44-7.16,9.62-7.16h6.94a43.33,43.33,0,0,0-.45,6.15c0,35.46,44.9,64.2,100.28,64.2C751.73,663.15,770.21,659.47,785.76,653.12Z",
    style: {
      fill: "#b97dff",
      fillOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.27,
    y: 674.2,
    width: 127.74,
    height: 3.11,
    style: {
      fill: "#b97dff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 782.28,
    cy: 617.43,
    rx: 7.81,
    ry: 16.07,
    style: {
      fill: "#e8d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.18,550.61c0,27.91-4,50.54-8.86,50.54s-8.85-22.63-8.85-50.54S859.18,522.7,859.18,550.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 849.72,
    cy: 495.51,
    r: 9.26,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "cheese"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.52,733.07v47.47a49.59,49.59,0,0,1,0,91.83V905.3H566.59a24.05,24.05,0,0,1,41.78,0h212V830.36c-.24,0-.48,0-.72,0a41.66,41.66,0,0,1,.72-67.93V733.07Zm330.35,65.8a15.47,15.47,0,1,1,15.47-15.47A15.47,15.47,0,0,1,677.87,798.87ZM457.21,834.65a10.94,10.94,0,1,1,10.93-10.93A10.94,10.94,0,0,1,457.21,834.65Zm335,38.6a20,20,0,0,1-4.81-34.57,23.49,23.49,0,0,1,4.81,34.57Z",
    style: {
      fill: "#fcee21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.24,682.24l-19.1,7.48-.48.19.48,0c0,7.42-4.61,13.92-11.46,17.51-8.74-.65-15.8-3-18.58-6l-9.65,3.78-70.93,27.8H820.41Zm102.23,21.58c5.19,0,9.81,1,12.69,2.47-.94,3.05-5.76,5.36-11.58,5.36-6.36,0-11.54-2.78-11.73-6.24A32.91,32.91,0,0,1,579.47,703.82Z",
    style: {
      fill: "#fcee21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.78,698.65c0,5-11.19,9-25,9-1.76,0-3.47-.07-5.12-.2,6.85-3.59,11.44-10.09,11.46-17.51C468.87,691,476.78,694.48,476.78,698.65Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.2,733.07c3.3,8.49-9,28.71-28.7,28.71s-32-20.22-28.7-28.71C456.84,720.08,504.16,720.08,509.2,733.07Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.51,796.63a42,42,0,0,0,17.18,33.71,34.29,34.29,0,0,1,.72-68.57v.64A42,42,0,0,0,802.51,796.63Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.41,830.36v.5l-.72-.52C819.93,830.36,820.17,830.36,820.41,830.36Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.33,776.88a49.42,49.42,0,0,0-17.81,3.29l-.46.18.46.19a49.59,49.59,0,0,1,0,91.83l-.46.18.46.18a49.58,49.58,0,1,0,17.81-95.85Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.2,873.25a23.48,23.48,0,1,1-4.81-34.57,20,20,0,0,0,4.81,34.57Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.31,710c0,3.4-7.09,6.15-15.84,6.15s-15.85-2.75-15.85-6.15c0-1.81,2-3.45,5.23-4.56.19,3.46,5.37,6.24,11.73,6.24,5.82,0,10.64-2.31,11.58-5.36C594.14,707.31,595.31,708.59,595.31,710Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 734.62,
    cy: 757.03,
    r: 8.11,
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.71,761.22a37.65,37.65,0,1,0,37.65,37.65A37.65,37.65,0,0,0,664.71,761.22Zm13.16,37.65a15.47,15.47,0,1,1,15.47-15.47A15.47,15.47,0,0,1,677.87,798.87Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.73,808.81a27.71,27.71,0,1,0,27.7,27.71A27.71,27.71,0,0,0,461.73,808.81Zm-4.52,25.84a10.94,10.94,0,1,1,10.93-10.93A10.94,10.94,0,0,1,457.21,834.65Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.73,902.86a19.61,19.61,0,0,1-.15,2.44,1.55,1.55,0,0,1,0,.31l-.17-.31a24.05,24.05,0,0,0-41.78,0l-.17.31a1.55,1.55,0,0,1,0-.31,19.61,19.61,0,0,1-.15-2.44,21.25,21.25,0,0,1,42.5,0Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552.81,
    cy: 867.45,
    r: 10.81,
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.8,733.07c-.68-5.28,19.47-13.3,36.85-14.8C503.44,717,521,720,521.5,724.69c.34,3.35-8.14,6.73-12.3,8.38C484.13,743.07,452.63,739.47,451.8,733.07Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.5,761.77c-12,0-21.28-7.53-25.93-15.34a31.07,31.07,0,0,0,41-13.36c.29-.54.57-1.09.82-1.66s.5-1.13.72-1.71c.1-.24.19-.5.28-.74s.16-.46.24-.7.15-.45.22-.68a0,0,0,0,0,0,0c.08-.25.16-.51.23-.77s.08-.26.11-.39l.15-.62s0-.1,0-.16c5.44,1.63,9.53,4.11,10.82,7.45C512.5,741.56,500.17,761.77,480.5,761.77Z",
    style: {
      fill: "#f9c023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.2,733.07H495.57c.29-.54.56-1.09.82-1.66s.5-1.13.72-1.71c.1-.24.19-.5.28-.74s.16-.46.24-.7.15-.45.22-.68a0,0,0,0,0,0,0c.08-.25.16-.51.23-.77s.08-.26.11-.39l.15-.62s0-.1,0-.16l.12-.53c0-.2.09-.4.13-.6s.08-.43.11-.65.1-.56.14-.83.07-.53.1-.8c0-.11,0-.22,0-.34s.05-.43.07-.65c.08-.9.12-1.81.12-2.74,0-.14,0-.29,0-.43,11.51.45,21.94,3.06,22.3,6.64C521.85,728,513.36,731.42,509.2,733.07Z",
    style: {
      fill: "#f7931e",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.41,762.41V733.07H495.57a31.06,31.06,0,0,1-54.85,0h-93.2v47.1l-.46.18.46.19a49.59,49.59,0,0,1,0,91.83l-.46.18.46.18V905.3H566.38a1.55,1.55,0,0,0,0,.31l.17-.31a24.05,24.05,0,0,1,41.78,0l.17.31a1.55,1.55,0,0,0,0-.31H820.41V830.36c-.24,0-.48,0-.72,0a41.66,41.66,0,0,1,.72-67.93Zm-363.2,72.24a10.94,10.94,0,1,1,10.93-10.93A10.94,10.94,0,0,1,457.21,834.65Zm220.66-35.78a15.47,15.47,0,1,1,15.47-15.47A15.47,15.47,0,0,1,677.87,798.87ZM792.2,873.25a20,20,0,0,1-4.81-34.57,23.49,23.49,0,0,1,4.81,34.57Z",
    style: {
      fill: "#f7931e",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.57,746.43a31.12,31.12,0,0,1-13.85-13.36H451.8C450.52,736.37,451.6,741.46,454.57,746.43Z",
    style: {
      fill: "#f7931e",
      opacity: 0.30000000000000004
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairy);
export default __webpack_public_path__ + "static/media/dairy.1d508ab7e93b62a9b1671f97c0ebca10.svg";
export { ForwardRef as ReactComponent };